export enum FirestoreCollection {
  Customers = 'customers',
  Prices = 'prices',
  Products = 'products',
  Subscriptions = 'subscriptions',
  Users = 'users',
}
